<script setup>
import { onMounted, ref, computed } from 'vue';
import { getNode } from '@formkit/core';
import { useAuthStore } from '@/stores/auth.js';
import SelectVigencia from '@/components/SelectVigencia.vue';
import SelectSeccionPresupuestal from './Common/GestionPresupuestal/SelectSeccionPresupuestal.vue';

const formVigencia = ref(null)

const authStore = useAuthStore();

const vigencia = ref(null);
const seccionPresupuestal = ref(null);

let modalSeleccionVigencia = null;
// const store = useUserInfoStore();

function submitForm() {
    const form = formVigencia.value.node;
    form.submit();
}

const submitHandler = async () => {
    const vigenciaNode = getNode('vigencia')
    const seccionNode = getNode('seccionPresupuestal')


    const objVigencia = {
        id: vigencia.value,
        vigencia: vigenciaNode?.props?.option?.label || ''
    }

    const objSeccionPresupuestal = {
        id: seccionPresupuestal.value,
        seccion: seccionNode?.props?.option?.label || ''
    }

    sessionStorage.setItem('anualidad', JSON.stringify(objVigencia));
    sessionStorage.setItem('seccionPresupuestal', JSON.stringify(objSeccionPresupuestal));

    authStore.vigencia = objVigencia;
    authStore.seccionPresupuestal = objSeccionPresupuestal;

    modalSeleccionVigencia.hide();
}

onMounted(() => {
    modalSeleccionVigencia = new bootstrap.Modal(document.querySelector('#modalSeleccionVigencia'), {
        keyboard: false,
        backdrop: 'static',
        focus: true,
    });

    if (sessionStorage.getItem('planDesarrollo') && JSON.parse(sessionStorage.getItem('planDesarrollo')).id) {
        authStore.planDesarrollo = JSON.parse(sessionStorage.getItem('planDesarrollo'));
    }

    /*VERIFICAR SI EXISTE SECCION PRESUPUESTAL Y VIGENCIA EN EL SESSION STORAGE*/
    if (sessionStorage.getItem('anualidad') && JSON.parse(sessionStorage.getItem('anualidad')).id && sessionStorage.getItem('seccionPresupuestal') && sessionStorage.getItem('seccionPresupuestal').id != "") {
        authStore.vigencia = JSON.parse(sessionStorage.getItem('anualidad'));
        authStore.seccionPresupuestal = JSON.parse(sessionStorage.getItem('seccionPresupuestal'));
    } else {
        modalSeleccionVigencia.show();
    }
})
</script>

<template>
    <div class="modal fade" id="modalSeleccionVigencia" tabindex="-1" aria-labelledby="modalSeleccionVigenciaLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
                <div class="modal-header bg-primary bg-gradient text-white py-1">
                    <h5 class="modal-title text-white"><i class="fas fa-calendar-alt"></i>
                        Vigencia</h5>
                </div>
                <div class="modal-body">

                    <FormKit ref="formVigencia" type="form" id="formVigencia" :actions="false" #default="{ value }"
                        @submit="submitHandler">

                        <div class="row gx-2">
                            <div class="col-12">
                                <SelectVigencia name="vigencia" id="vigencia" label="Vigencia" placeholder="Vigencia"
                                    validation="required" v-model="vigencia" />
                            </div>
                        </div>

                        <div class="row gx-2 pt-2">
                            <div class="col-12">
                                <SelectSeccionPresupuestal name="seccionPresupuestal" id="seccionPresupuestal"
                                    label="Sección presupuestal" placeholder="Sección presupuestal"
                                    v-model="seccionPresupuestal" validation="required"
                                    :url="'/api/v1/auth/dropdown/seccionpresupuestal'" :havetransactions="false"
                                    open-on-focus />
                            </div>
                        </div>
                    </FormKit>
                </div>

                <div class="modal-footer border-0 py-1">
                    <button type="submit" @click="submitForm" class="btn btn-success py-0">Guardar</button>
                </div>
            </div>
        </div>
    </div>
</template>
